import http from '@/communication/AuthConnection'

export default async (form) => {
  try {
    const responsePayload = await http.put(`/v1/distributor/${form.id}`, form)
    return responsePayload.data
  } catch (e) {
    return Promise.reject(new Error('ok'))
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/distributor/update-distributor/index.js